// The order a guard works a job's (non-airport) stops: by scheduled time,
// untimed stops after in their saved order — unless the guard reordered by
// hand (stopsManuallyOrdered), then saved order. Same rule the outbound
// execution list uses, so My Jobs, the start screen and the stop list all
// number stops 1, 2, 3… the same way. Display only; never written back.
export function guardWorkOrder(job) {
  const real = (job?.stops || []).filter((s) => s.type !== "airport");
  if (job?.stopsManuallyOrdered) return real;
  return real
    .map((s, i) => ({ s, i }))
    .sort((a, b) => {
      const ta = a.s.scheduledTime || "";
      const tb = b.s.scheduledTime || "";
      if (ta && tb) return ta.localeCompare(tb) || a.i - b.i;
      if (ta) return -1;
      if (tb) return 1;
      return a.i - b.i;
    })
    .map(({ s }) => s);
}
